var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAestheticsPrinciple1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1579_8401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0.764648H0V40.7646H40V0.764648Z",
    fill: "#68D086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 20.7646C40 9.71895 31.0457 0.764648 20 0.764648C8.9543 0.764648 0 9.71895 0 20.7646C0 31.8103 8.9543 40.7646 20 40.7646C31.0457 40.7646 40 31.8103 40 20.7646Z",
    fill: "#60BE7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0.764648L37.3205 30.7646H2.67944L20 0.764648Z",
    fill: "white",
    fillOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1579_8401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAestheticsPrinciple1);
export default __webpack_public_path__ + "static/media/aesthetics-principle 1.f4bc958bd884b876f8d48ee8abc93913.svg";
export { ForwardRef as ReactComponent };